<template>
  <svg t="1777269153680" class="icon pointer" viewBox="0 0 1024 1024" version="1.1" fill="#646464" xmlns="http://www.w3.org/2000/svg" p-id="6158" width="16" height="16" @click="$emit('click')">
    <path d="M1019.733333 494.933333C1011.2 477.866667 832 128 512 128S12.8 477.866667 4.266667 494.933333c-4.266667 12.8-4.266667 25.6 0 38.4 0 0 0 4.266667 4.266666 4.266667C34.133333 584.533333 209.066667 896 512 896c320 0 499.2-349.866667 507.733333-366.933333 4.266667-8.533333 4.266667-25.6 0-34.133334zM512 810.666667c-230.4 0-379.733333-230.4-422.4-298.666667C128 443.733333 281.6 213.333333 512 213.333333s379.733333 230.4 422.4 298.666667c-42.666667 68.266667-192 298.666667-422.4 298.666667z" p-id="6159"></path>
    <path d="M512 341.333333c-93.866667 0-170.666667 76.8-170.666667 170.666667s76.8 170.666667 170.666667 170.666667 170.666667-76.8 170.666667-170.666667-76.8-170.666667-170.666667-170.666667z m0 256c-46.933333 0-85.333333-38.4-85.333333-85.333333s38.4-85.333333 85.333333-85.333333 85.333333 38.4 85.333333 85.333333-38.4 85.333333-85.333333 85.333333z" p-id="6160"></path>
  </svg>
</template>

<script>
export default {
  name: 'EyeIcon',
  emits: ['click']
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>